import React, { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import api from "@/lib/api";

const SAMPLE_STORIES = [
  {
    name: "Rohit Verma",
    role_title: "Salesforce Admin → Data Cloud Consultant",
    photo: "https://images.unsplash.com/photo-1651684215020-f7a5b6610f23",
    message: "The daily streak kept me consistent — by Day 30 I'd rebuilt my whole resume around the simulator projects. Got a Data Cloud Consultant offer within 3 weeks of finishing.",
    rating: 5,
  },
  {
    name: "Ananya Kulkarni",
    role_title: "Business Analyst → Data Cloud Architect",
    photo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e",
    message: "The AI Mentor explained Identity Resolution better than any course I'd paid for. The case studies felt like real client work, not tutorials.",
    rating: 5,
  },
  {
    name: "Karan Mehta",
    role_title: "Fresh Graduate → Data Cloud Developer",
    photo: "https://images.unsplash.com/photo-1762522927402-f390672558d8",
    message: "No prior Salesforce experience — the mock interviews gave me the confidence to walk into real interviews. Landed my first job straight out of college.",
    rating: 5,
  },
  {
    name: "Sneha Reddy",
    role_title: "Marketing Ops → Data Cloud Specialist",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2",
    message: "I was switching careers with zero technical background. The 30-day structure made it click — one challenge at a time, no overwhelm.",
    rating: 5,
  },
];

export default function SuccessStoriesSection() {
  const [realStories, setRealStories] = useState([]);

  useEffect(() => {
    api.get("/public/testimonials").then((r) => setRealStories(r.data || [])).catch(() => setRealStories([]));
  }, []);

  const stories = realStories.length >= 4 ? realStories : [...realStories, ...SAMPLE_STORIES.slice(0, 4 - realStories.length)];

  return (
    <section className="max-w-7xl mx-auto px-6 py-24" data-testid="success-stories-section">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-400">Success Stories</span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-3">Real learners. Real career outcomes.</h2>
        <p className="text-slate-400 mt-3">Join thousands of learners across every domain who leveled up with the challenge.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {stories.map((s, i) => (
          <div
            key={s.id || s.name}
            data-testid={`success-story-card-${i}`}
            className="glass-panel rounded-2xl p-6 flex flex-col hover:-translate-y-1 hover:border-indigo-400/30 transition-all duration-300"
          >
            <Quote className="w-5 h-5 text-indigo-400/50 mb-3 shrink-0" />
            <p className="text-sm text-slate-300 leading-relaxed flex-1">&ldquo;{s.message}&rdquo;</p>
            <div className="flex items-center gap-1 mt-4 mb-3">
              {Array.from({ length: 5 }).map((_, si) => (
                <Star key={si} className={`w-3.5 h-3.5 ${si < (s.rating || 5) ? "text-amber-400 fill-amber-400" : "text-slate-600"}`} />
              ))}
            </div>
            <div className="flex items-center gap-3 pt-3 border-t border-white/10">
              <img src={s.photo} alt={s.name} loading="lazy" className="w-10 h-10 rounded-full object-cover shrink-0" />
              <div>
                <p className="text-sm font-semibold text-white">{s.name}</p>
                <p className="text-[11px] text-slate-400">{s.role_title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
